
export default function HeroSection() {
  return (
    <section className="relative bg-slate-900 text-white py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a475af47b7d5411d714f8b30bdba84bf.jpg"
          alt="Hukuk Bürosu Arka Plan"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-slate-900/70"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins">
          Hakkımızda
        </h1>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
          Güven, deneyim ve profesyonellikle hukuki ihtiyaçlarınızda yanınızdayız
        </p>
      </div>
    </section>
  );
}